<template>
    <v-container fluid>
        <v-row align="center" justify="center">
            <v-col cols="12" sm="12" lg="10" xl="6">
                <InstituteTable/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import InstituteTable from "../components/institute/InstituteTable";
    export default {
        name: "Institutes",
        components: {InstituteTable}
    }
</script>

<style scoped>

</style>